export default __webpack_public_path__ + "static/media/arrow-right.eadfcb1f.svg";